import React from "react";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import InputFields from "../../utils/UserInput";
import { Modal, message } from "antd"; 
import { postRequest } from "../../utils/APICall";
import moment from "moment";
import { useSelector } from "react-redux";
import { XMarkIcon } from "@heroicons/react/16/solid";

const DesignationForm = ({ visible, onClose }) => {
  const { users } = useSelector((state) => state.user || {})

  const validationSchema = Yup.object().shape({
    vdestitle: Yup.string().required("Title is required"),
  });

  const initialValues = {
    vdestitle: "",
  };

  const handleSubmit = async (values, { resetForm }) => {
    try {
      const payload = {
        vdesignationid: 0,
        vdestitle: values.vdestitle,
        vcreatedby: `${users?.FIRSTNAME} ${users?.LASTNAME} | ${moment(Date.now()).format("DD-MM-YYYY HH:mm")}`,
      };
      const response = await postRequest("addDesignation", payload);

      if (response.success) {
        message.success(response.message || "Designation added successfully");
        resetForm();
        onClose();
        window.location.reload()
      } else {
        message.error("Failed to add designation");
      }
    } catch (error) {
      message.error("An error occurred while submitting the form.");
    }
  };

  const showConfirm = (values, formikBag) => {
    Modal.confirm({
      title: 'Confirm Submission',
      content: 'Are you sure you want to add this designation?',
      okText: 'Yes',
      cancelText: 'No',
      onOk: () => handleSubmit(values, formikBag),
    });
  };

  return (
    <Modal
      title={
        <div className="text-xl font-bold text-center pb-3 dark:bg-gray-900 dark:text-gray-100">
          Add Designation
        </div>
      }
      open={visible}
      onCancel={onClose}
       closeIcon={
        <XMarkIcon
          className={"h-5 w-5  dark:text-white text-black"}
        />
      }
      footer={null}
      className="dark:[&_.ant-modal-content]:bg-gray-900"
    >
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={(values, formikBag) => showConfirm(values, formikBag)}
      >
        {({ isValid, dirty }) => (
          <Form>
            <div className="grid gap-4 dark:bg-gray-900 dark:text-gray-100">
              <InputFields
                label="Title"
                type="text"
                placeholder="Designation Title"
                name="vdestitle"
              />
              <button
                type="submit"
                className="bg-blue-500 text-white py-2 px-4 rounded w-full"
                disabled={!(isValid && dirty)}
              >
                Submit
              </button>
            </div>
          </Form>
        )}
      </Formik>
    </Modal>
  );
};

export default DesignationForm;